<template>

    <div ref="diagram" :class="!isFull ? 'diagram' : 'full'" :style="kuan ? kuanStyle : ''">
        <div class="move-box">
            <div class="upmask">
                
                <div class="titleAll-nav" >
                    <div class="nav" v-if="IsNone == 1">
                        <!-- <img :src="seat" alt="" /> -->
                        <b>{{ title }}</b>
                    </div>
                    <div class="Op" v-else>{{ site }}</div>
                </div>

                <div class="date">
                    <div class="time">
                        <div class="hour">{{currentDate.hour}}</div>
                        <div class="year">{{currentDate.year}}</div>
                    </div>
                    <div class="city">{{currentDate.city}}</div>
                    <div class="weather">{{currentDate.temperatrue}}° <span>{{currentDate.weather}}</span></div>
                    <div class="humi"><span>湿度</span> {{currentDate.humi}}%</div>
                </div>
            </div>
            <iframe name="Gis" width="100%" height="100%" ref="iframeWindow" class="small"
                :src="IsNone != 1?url : $store.state.project.projectInfo.webgisUrlWhite">
            </iframe>

            <!-- <iframe name="Gis" width="100%" height="100%" ref="iframeWindow" class="small"
                src="http://127.0.0.1:5500/public/level/chSite.html">
            </iframe> -->

            <div class="clickbtn-rongt" v-show="IsNone == 1">
                <div :class="menuIdx == index?'nin_select selected':'nin_select'"  v-for="(item,index) in data" :key="item.id" @click="sendMessage(item.values,index)">
                    <img :src="item.src" alt="" /><span>{{item.name}}</span>
                </div>
                <div class="sitePoPup" v-show="showsite">
                    <div :class="seDx == index?'siteCon se':'siteCon'" v-for="(item,index) in siteList" :key="item.id" @click="selectSite(index,item.val)">
                        {{item.site}}
                    </div>
                </div>
            </div>
            <div class="clickbtn-rongt1" v-show="IsNone == 2">
                <div :class="current == index?'nin_select selected':'nin_select'"  v-for="(item,index) in list" :key="item.id" @click="addClass(index, item.className)">
                    <span><img :src="current == index?item.img2:item.img1" alt="">{{item.name}}</span>
                    <span>{{item.Btq}}台</span>
                </div>
            </div>
            <div class="nin_btn" v-show="IsNone == 3">
                <div :class="flag?'nin_select selected':'nin_select'" @click="flag = !flag">
                    <span><img :src="flag?require('../../../assets/img/nibianqi_sel.png'):require('../../../assets/img/nibianqi_nor.png')" alt="">逆变器</span>
                    <span>0台</span>
                </div>
            </div>
            <div class="nin_btn" v-show="IsNone == 4">
                <div :class="!flag?'nin_select selected':'nin_select'" @click="flag = !flag">
                    <span><img :src="!flag?require('../../../assets/img/chunengdianchi_sel.png'):require('../../../assets/img/chunengdianchi_nor.png')" alt="">变流器</span>
                    <span>0台</span>
                </div>
                <div :class="flag?'nin_select selected':'nin_select'" @click="flag = !flag">
                    <span><img :src="flag?require('../../../assets/img/chunengdianchi_sel.png'):require('../../../assets/img/chunengdianchi_nor.png')" alt="">储能电池</span>
                    <span>0台</span>
                </div>
            </div>
            <router-link :to="'/3D/' + page" >
                <div class="Downmask1">
                    <img src="../../../assets/img/矢量智能对象.png" alt="" />
                    <p class="rouling">进入大屏显示</p>
                </div>
            </router-link>
            <!-- <div class="Downmask"></div> -->
        </div>
        <div class="btn row-center" v-show="!kuan" v-if="!isFull" @click="full">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span><img src="@/assets/img/full.png" title="全屏"></span>
        </div>
        <div class="btn row-center" v-else @click="cancelFull">
            <!-- <img src="@/assets/img/full_cancel.png" alt="取消全屏"> -->
            <span><img src="@/assets/img/qwhite.png" title="取消全屏"></span>
        </div>

        <div class="btn row-center" v-if="!isFull && !kuan" @click="onkuan" style="right: 66rem">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span style="margin-right: 18px"><img src="@/assets/img/widescreen.png" title="宽屏"></span>
        </div>

        <div v-show="!isFull" class="btn row-center" v-else @click="kuan = false" style="right: 20rem">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span style=""><img src="@/assets/img/kwhite.png" title="取消宽屏"></span>
        </div>
    </div>

</template>
<script>
    import {chainIndex} from "../../../api/linkindex";
    export default {
        //   components: { echars },
        data() {
            return {
                projectCoordinate:'', // 经纬度查询天气
                currentDate:{     // 当前时间天气
                    hour:'15:26:48',
                    year:'2022年03月15日',
                    city:'武汉',
                    weather:'晴',
                    temperatrue:'26',
                    humi:'63'
                },
                menuIdx:0,
                flag:true,
                seDx:-1,
                page:'all',
                data: [{
                        id: 1,
                        name: "概况",
                        src: require("../../../assets/img/主视角.png"),
                        values: "parkOverview",
                    },
                    {
                        id: 2,
                        name: "分布",
                        src: require("../../../assets/img/站点概览.png"),
                        values: "siteAll",
                    },
                    {
                        id: 3,
                        name: "供电",
                        src: require("../../../assets/img/电力桥架.png"),
                        values: "electricLine",
                    },
                ],
                //一开始选中的值
                current: 0,
                //循环的数组
                list: [
                    
                    {
                        id: 2,
                        name: "变压设备",
                        img1: require("../../../assets/img/变压器1.png"),
                        img2: require("../../../assets/img/变压器2.png"),
                        Btq: '',
                        className: "变压设备",
                    },
                    {
                        id: 1,
                        name: "低压配电",
                        img1: require("../../../assets/img/低压馈线柜1.png"),
                        img2: require("../../../assets/img/低压馈线柜2.png"),
                        Btq: '',
                        className: "低压配电",
                    },
                    {
                        id: 3,
                        name: "高压配电",
                        img1: require("../../../assets/img/低压进线柜1.png"),
                        img2: require("../../../assets/img/低压进线柜2.png"),
                        Btq: '',
                        className: "高压配电",
                    }
                ],
                //延时器3M
                timer: "",
                //控制
                IsNone: 0,
                kuan: false,
                isFull: false,
                url: "",
                id: 0,
                seat: require("../../../assets/img/ebs.png"),
                title: "",
                site: "",
                iframeWin: {},
                siteList:[
                    {
                        id:1,
                        site:'变配电',
                        val:'siteOverview'
                    },
                    {
                        id:2,
                        site:'微电网',
                        val:'siteWeidian'
                    },
                ] , // 点击分布的站点列表 
                showsite:false
            };
        },
        mounted() {
            this.IsNone = this.$store.state.homeitem.Dclick;
            this.iframeWin = this.$refs.iframeWindow.contentWindow;
            window.addEventListener("message", this.handleMessage);
            this.getTil();
            this.howtall();
            let _this = this
            setTimeout(()=>{
                _this.iframeWin.postMessage({
                    cmd: "parkOverview",
                },"*")
                console.log('进入三维');
            },3000)

            setInterval(()=>{
                _this.formatDate("YYYY年MM月DD日 hh:mm:ss", new Date())
            },1000)
            setInterval(()=>{
                _this.getWeatherInfo()
            },10*60*1000)

            let site = localStorage.getItem('currentSiteId')
            console.log(site);
            if(site){
                this.iframeSite()
                this.current = 0
                this.menuIdx = 0
            }
        },
        created(){
            
        },
        beforeDestroy() {
            window.removeEventListener("message", this, this.handleMessage);
            clearTimeout(this.timer);

            // this.IsNone = 1;
            // this.$store.commit("Dthere", 1);
        },
        watch: {
            "$store.state.homeitem.areaId"(n, o){
                let _this = this
                    console.log(n + '当前站点')
                if(n){
                    this.howtall()
                    this.iframeSite()
                    this.current = 0
                    this.menuIdx = 0
                    localStorage.setItem('currentSiteId',n)
                    
                    setTimeout(()=>{
                        _this.addClass(0, '变压设备')
                        console.log('站点');
                    },10000)
                }
            },
            "$store.state.homeitem.Dclick"(n, o) {
                let _this = this
                if (n == 1) {
                    this.IsNone = 1;
                    this.site = "";
                    this.url = null
                    setTimeout(()=>{  
                        _this.iframeWin.postMessage({
                            cmd: "parkOverview",
                        },"*")
                        console.log('进入三维');
                    },8000)
                }else{
                    this.IsNone = n;
                    this.getDevices()

                }
            },
        },
        methods: {
            // 查询当前项目所在城市 
            getCity(location){
                fetch('https://geoapi.qweather.com/v2/city/lookup?location=' + location +
                        '&key=154645a21e7c47c4bb5f0657c7b1ad63').then(res => res.json()).then(res=>{
                            this.currentDate.city = res.location[0].adm2
                        })
            },
            getWeatherInfo(location) {
                 // 和风天气api 10000/天 可通过经纬度查询
                fetch('https://devapi.heweather.net/v7/weather/now?location=' + location +
                        '&key=154645a21e7c47c4bb5f0657c7b1ad63')
                    .then(response => response.json())
                    .then(json => {
                        // console.log(json);
                        this.currentDate.temperatrue = json.now.temp;
                        this.currentDate.weather = json.now.text;
                        this.currentDate.humi = json.now.humidity;
                    })
            },
            
            // 初始化时间
            formatDate(fmt, date){
                let timeObj = {
                    "Y+":date.getFullYear().toString(),
                    "M+":(date.getMonth() + 1).toString(),
                    "D+":date.getDate().toString(),
                    "h+":date.getHours().toString(),
                    "m+":date.getMinutes().toString(),
                    "s+":date.getSeconds().toString(),
                }
                // console.log(timeObj);
                for (let k in timeObj) {
                    let ret = new RegExp("(" + k + ")").exec(fmt);
                    if (ret) {
                        fmt = fmt.replace(ret[1], ret[1].length == 1 ? timeObj[k] : timeObj[k].padStart(ret[1].length, "0"));
                    }
                }
                this.currentDate.year = fmt.substr(0,11)
                this.currentDate.hour = fmt.substr(12)
            },
            // 当前是站房的时候的三维站点
            async iframeSite(){
                let res = await chainIndex.site(this.$store.state.project.currentProject.projectId)
                    if (res.data.data.areas) {
                        let obj = res.data.data.areas.find(item => item.areaId == this.current_area)
                            
                        this.url = obj.modelParams
                        this.site = obj.areaName
                    }
            },
            // 获取设备
            async getDevices(){
                let res = await chainIndex.site(this.$store.state.project.currentProject.projectId)
                let devices = res.data.data.areas.find(item =>item.areaId == this.$store.state.homeitem.areaId)

                this.site = devices.areaName;
                this.url = devices.modelParams;
                this.$store.commit("mantotal", devices.areaName);
                this.$store.commit("getpng", devices.areaImg);

                let res1 = await chainIndex.breaker(devices.areaId)
                this.$store.commit("voltageClasses1", res1.data.data.result[0])
                this.$store.commit("voltageClasses2", res1.data.data.result[1])
                        
            },
            //切换
            addClass(index, type) {
                this.current = index 
                // console.log(type)
                this.iframeWin.postMessage({
                        cmd: "showDevice",
                        type: type,
                        devices: "",
                    },"*");
            },

            //变压器台数
            howtall() {
                chainIndex.QueryFacility(this.$store.state.homeitem.areaId).then(res => {
                    console.log(res)
                    let a = 0;
                    let b = 0;
                    let c = 0;
                    let d = 0
                    if (JSON.stringify(res.data.data) != "{}") {
                        res.data.data.result.forEach(item => {
                            // console.log(item);
                            if (item.type == "变压设备") {
                                a = item.num
                            }
                            if (item.type == "高压配电") {
                                b = item.num
                            }
                            if (item.type == "低压配电") {
                                c = item.num
                            }
                            if (item.type == "新能源设备") {
                                d = item.num
                            }

                        })
                    }
                    this.$set(this.list[0], 'Btq', a)
                    this.$set(this.list[1], 'Btq', c)
                    this.$set(this.list[2], 'Btq', b)
                })
           
            },
            handleMessage(event) {
                const data = event.data;
                // console.log(data);
                switch (data.cmd) {
                    case "ThreeLoadEnd":
                        this.iframeWin.postMessage({
                                cmd: "noDetailUI",
                            },
                            "*"
                        );
                        break;
                    case "loadEnd":
                        if (this.$store.state.homeitem.Dclick != 1) {
                            this.IsNone = this.$store.state.homeitem.Dclick
                            // this.$store.commit("setData", 1);
                            this.getDevices()
                        } else {
                            // @to do
                            // 地图加载完成的处理（有3秒的飞行动画）
                            this.IsNone = 1;
                            // this.$store.commit("setData", 0);
                            this.site = "";

                        }

                        break;
                        // 点击三维内站房传回数据
                    case "returnData":
                        console.log(data);
                        this.$store.commit("webId", data.params.data.id)
                        if(data.params.data.type == "site"){
                            this.IsNone = 2
                            this.$router.push({
                                path:`/SubstationManagement`,
                                name:'SubstationManagement',
                                query:{
                                    name:"PowerDistribution",
                                    id:data.params.data.id
                                },
                            })
                        }else if(data.params.data.type == "pv"){
                            this.IsNone = 3
                            this.$router.push({
                                path:'/SubstationManagement',
                                name:'SubstationManagement',
                                query:{name:"PowerProfile",id:data.params.data.id}
                            })
                        }else if(data.params.data.type == "container"){
                            this.IsNone = 4
                            this.$router.push({
                                path:'/SubstationManagement',
                                name:'SubstationManagement',
                                query:{name:"PtorageSituation",id:data.params.data.id}
                            })
                        }

                        this.$store.commit("Dthere", 2)
                        console.log(this.isNone);
                        break;
                    case "current":
                        console.log(data);
                        this.current = data.params
                        break;
                }
            },
            // @to do
            // 清除事件
            sendMessage(value,idx) {
                this.menuIdx = idx 
                if(idx == 1){
                    this.showsite = !this.showsite
                }else{
                    this.showsite = false
                    this.iframeWin.postMessage({
                        cmd: "clearElectricLine",
                    },"*")
                    this.iframeWin.postMessage({
                            cmd: "clearSiteOverview",
                    },"*")
                    this.iframeWin.postMessage({
                            cmd: "clearParkOverview",
                    },"*")
                    this.iframeWin.postMessage({
                            cmd: value,
                    },"*")
                }
            },
            selectSite(idx,val){
                this.seDx = idx
                this.iframeWin.postMessage({
                    cmd: "clearElectricLine",
                },"*")
                this.iframeWin.postMessage({
                        cmd: "clearSiteOverview",
                },"*")
                this.iframeWin.postMessage({
                        cmd: "clearParkOverview",
                },"*")
                this.iframeWin.postMessage({
                    cmd: val,
                },"*")
                this.showsite = false
            },
            getTil() {
                chainIndex
                    .getData(this.$store.state.project.currentProject.projectId)
                    .then((res) => {
                        // console.log(res);
                        this.title = res.data.data.project.projectName;
                        this.seat = res.data.data.project.projectIcon;
                        this.location = res.data.data.project.projectCoordinate
                        this.getWeatherInfo(this.location)
                        this.getCity(this.location)
                    });
                
            },

            full() {
                this.isFull = true;
            },
            cancelFull() {
                this.isFull = false;
                this.reset();
            },

            onkuan() {
                this.kuan = true;
            },
        },
        computed: {
            kuanStyle() {
                if (this.kuan) {
                    return `
                        width: 84%;
                        height:90%;
                        position: fixed;
                        top: 6%;
                        left: 14%;
                        bottom: 0;
                        right: 0;
                        margin: auto;
                        z-index: 9999;
                    `;
                }
                return;
            },
            current_area(){
                return this.$store.state.homeitem.areaId
            }
        },
    };
</script>
<style lang="less" scoped>
    #ifromD {
        width: 100%;
        height: 100%;
    }

    .full {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 1);
        z-index: 9999;
    }

    .diagram {
        width: 100%;
        height: 100%;
        overflow: hidden;
        // position: relative;
        background-color: rgba(0, 0, 0, 0);
    }

    /*定义滚动条轨道 内阴影+圆角*/


    .detail {
        font-size: 18rem;
        color: #fff;
        position: absolute;
        top: 24rem;
        left: 24rem;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .tableContainer {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .move-box {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #ffffff;
    }

    .small,
    .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        /*transition: all 0.1s;*/
    }

    .mask {
        width: 100%;
        height: 100%;
    }

    .btn {
        position: absolute;
        bottom: 8rem;
        right: 24rem;
        color: #ffffff;
        font-size: 20rem;
        cursor: pointer;
        z-index: 111;
    }

    .upmask {
        height: 90rem;
        position: absolute;
        width: 100%;
        z-index: 9;
        background-image: linear-gradient(rgb(0, 0, 0, 1), rgba(0, 0, 0, 0));

        .titleAll-nav {
            .nav {
                font-size: 24px;
                color: #fff;
                padding: 20rem 0 0 26rem;
            }
        }
        .Op {
            font-size: 24px;
            color: #fff;
            padding: 20rem 0 0 26rem;
        }
        
        .date{
            width: 370rem;
            height:40rem ;
            // background-color: #fff;
            position: absolute;
            color: #fff;
            right: 20rem;
            top: 20rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: Source Han Sans CN;
            font-size: 24rem;

            .time{
                width:120rem ;
                text-align: center;
                .hour{
                    font-weight: 500;
                }
                .year{
                    font-size: 14rem;
                    padding-left: 3rem;
                    margin-top: -8rem;
                }
            }
            .city{
                font-weight: 500;
                padding: 0 16rem;
                border-left: 1px solid #fff;
                border-right: 1px solid #fff;
            }
            .weather{
                span{
                    font-size: 16rem;
                }
            }
            .humi{
                span{
                    font-size: 16rem;
                }
            }
        }
    }

    .Downmask {
        height: 70rem;
        position: absolute;
        width: 100%;
        bottom: 0;
        z-index: 0;
        // background-image: linear-gradient(rgba(0, 0, 0, 0), rgb(0, 0, 0, 1));
        
        background: linear-gradient(0deg, #F3F9FF 0%, rgba(243, 249, 255, 0.3) 100%);
    }

    .Downmask1 {
        height: 43px;
        position: absolute;
        width: 157px;
        bottom: 100rem;
        left: 24rem;
        z-index: 0;
        background: #ffffff;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .Downmask1:hover {
        background-color: rgba(102, 160, 207, 0.9);
    }

    .rouling {
        width: 87px;
        height: 13px;
        font-size: 16px;
        font-family: "YouSheBiaoTiHei";
        font-weight: 400;
        color: #333333;
        line-height: 14px;
        white-space: nowrap;
        margin-left: 7rem;
    }

    .clickbtn-rongt {
        width: 3.4vw;
        height: 22.5vh;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 0;
        background: #ffffff;
        border-radius: 12px;
        cursor: pointer;
        bottom: 80rem;
        left: 24rem;
        display: flex;
        align-items: center;
        padding: 0.5vh 0;
        justify-content: space-evenly;
        flex-direction: column;
        
        .nin_select{
            width: 100%;
            height: 55rem;
            padding-top: 5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            box-sizing: border-box;
            border:2px solid transparent ;
            &>img{
                display: block; 
                width:22px ;
                height: 20px;
            }
            &>span{
                display: block;
                color: #333;
                font-size: 14px;
            }
        }
        
        .selected{
            border-right:2px solid #0d94ff ;
            color: #0d94ff;
            background-color: rgba(13,148,255, 0.1);
        }
        

        .sitePoPup{
            position: absolute;
            right: -6.5vw;
            top: 6.2vh;
            width:5.3vw;
            height: 10vh;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            color: #333;
            justify-content:center;
            align-items: center;
            border-radius: 8px;

            
            .siteCon{
                width:4vw ;
                height: 4vh;
                text-align: center;
                line-height: 36px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.08);
                
                &:hover{
                    color: #0d94ff;
                }
            }
            .se{
                    color: #0d94ff;
                }
            .siteCon:last-child{
                border: none;
            }
        }
        .sitePoPup:before{
            content: '';
            width: 0;
            height: 0;
            border: 1vh solid transparent;
            border-right: 1vh solid #fff;
            position: absolute;
            left: -1vw;
            top: 4vh;
        }
    }

    .clickbtn-rongt1 {
        z-index: 111;
        cursor: pointer;
        position: absolute;
        width: 8.2vw;
        bottom: 155rem;
        left: 24rem;
        z-index: 0;
        background: #ffffff;
        border-radius: 12px;
        padding: 8px 2px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        .nin_select{
            width: 100%;
            height: 25px;
            line-height: 25px;
            border-radius: 7px;
            display: flex;  
            justify-content: space-between;
            padding: 0 14px;
            background-color: #fff;
            margin-bottom: 6px;
            span{
                img{
                    width: 18rem;
                    height: 18rem;
                    vertical-align: middle;
                    margin-top: -1px;
                    margin-right: 8px;
                }
            }
            &:hover{
                // color:#0d94ff;
                background-color: #e2f2ff;
            }
        }
        .selected{
            color:#0d94ff;
            background-color: #e2f2ff;
        }
    }

    .nin_btn{
        // height: 43px;
        z-index: 111;
        cursor: pointer;
        position: absolute;
        width: 8.2vw;
        bottom: 155rem;
        left: 24rem;
        z-index: 0;
        background: #ffffff;
        border-radius: 12px;
        padding: 8px 2px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        .nin_select{
            width: 100%;
            height: 25px;
            line-height: 25px;
            border-radius: 7px;
            display: flex;  
            justify-content: space-between;
            padding: 0 14px;
            background-color: #fff;
            margin-bottom: 6px;
            span{
                img{
                    width: 10px;
                    height: 14px;
                    vertical-align: middle;
                    margin-top: -1px;
                    margin-right: 8px;
                }
            }
            &:hover{
                // color:#0d94ff;
                background-color: #e2f2ff;
            }
        }
        .selected{
            color:#0d94ff;
            background-color: #e2f2ff;
        }
        
    }
</style>